<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button type="primary" class="add" size="small" @click="addTeam">
        <i class="el-icon-plus"></i>
        新增代表队
      </el-button>
      <el-button type="primary" class="add" size="small" @click="addAdminTeam">
        <i class="el-icon-plus"></i>
        多开代表队
      </el-button>      
      <el-button type="danger" size="small" class="delete" @click="delMulData">
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入代表队名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
     <el-table-column
        width="80"
        prop="id"
        label="序号"       
        align="center"
      >
    <template slot-scope="scope">
      {{ (searchForm.page - 1) * searchForm.pageSize + scope.$index + 1 }}
    </template>
    </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="代表队名称"
      ></el-table-column>
      <el-table-column
        prop="caption"
        align="center"
        label="领队"
      ></el-table-column>
      <el-table-column
        prop="coach"
        align="center"
        label="教练"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        align="center"
        label="手机号"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deleteTeam(scope.row)"
            class="btn"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editTeam(scope.row)"
            class="btn"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[1, 5, 15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'新增代表队'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="代表队名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="领队" prop="caption">
          <el-input v-model="form.caption" maxlength="255"></el-input>
        </el-form-item>
         <el-form-item label="教练" prop="coach">
          <el-input v-model="form.coach" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button>
      </div>
    </el-dialog>    
    <el-dialog
      :title="'多开代表队'"
      :inline="true"
      :visible.sync="dialogAdminFormVisible"
    >
      <el-form
        :model="adminform"
        label-position="right"
        label-width="110px"
        :rules="adminformRules"
        ref="adminform">
      <el-form-item label="账户" prop="userId">
        <el-select  v-model="adminform.userId"  filterable clearable   style="width: 100%">
              <el-option
                v-for="item in userOptions"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              ></el-option>
            </el-select>
      </el-form-item>
        <el-form-item label="代表队名称" prop="name">
          <el-input v-model="adminform.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="领队" prop="caption">
          <el-input v-model="adminform.caption" maxlength="255"></el-input>
        </el-form-item>
         <el-form-item label="教练" prop="coach">
          <el-input v-model="adminform.coach" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="adminform.mobile" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdminFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdminForm" :loading="isLoading"
          >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/team'
import USERAPI from '../apis/account'
export default {
  data () {
    return {
      isLoading: false,
      dialogFormVisible: false,
      dialogAdminFormVisible:false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      searchForm: {
        name: null,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        name: '',
        caption: '',
        coach: '',
        mobile: ''
      },
      userOptions:[],
       adminform: {
        id: 0,
        userId:null,
        name: '',
        caption: '',
        coach: '',
        mobile: ''
      },
      formRules: {
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        caption: [{ required: true, message: '请输入领队', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      },adminformRules:{
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        caption: [{ required: true, message: '请输入领队', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        userId: [{ required: true, message: '请选择用户账户', trigger: 'blur' }],
      }
    }
  },
  methods: {
    editTeam (row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    //新增部门表单弹框
    addTeam () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
      addAdminTeam () {
      this.dialogAdminFormVisible = true
      this.$nextTick(() => {
        this.$refs['adminform'].resetFields()
      })
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    submitAdminForm(){
       let that = this;
      this.isLoading = true
      this.$refs.adminform.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.adminform)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogAdminFormVisible = false;
                that.$refs['adminform'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.adminAdd(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['adminform'].resetFields();
                this.dialogAdminFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    
    },
    deleteTeam (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          console.log(result)
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: '系统错误', duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  },
  computed: {
  },
  mounted () {
    this.search();
      USERAPI.select().then((result) => {
        if (result && result.code == 0) {
          this.userOptions = result.result;
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Teams.vue